import React from "react";
import {
  PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, Funnel, FunnelChart, LabelList,
  ResponsiveContainer,
  AreaChart,
  Area,
  CartesianGrid, LineChart, Line
} from "recharts";
import { DollarSign, Package, ShoppingBag, Phone, RotateCcw, TrendingUp, PhoneCall, Users, RefreshCw, Calendar } from 'lucide-react';
import { useUserContext } from '../../context/DealerProfile';
import { useState, useEffect } from "react";
import useSWR from "swr";
import useHourlyRefreshLimit from "../useHourlyRefreshLimit";






// import {

// } from 'recharts';

// const COLORS = ["#FF5733", "#33FF57", "#3380FF", "#FF33A6", "#FFC733", "#8D33FF"];





// const MonthWiseOrdersChart = ({ selectedYear, handleYearChange }) => {


const Dashboard = ({ filter = "this-month" }) => {
  const dealerDetail = useUserContext();

  const [initialLoad, setInitialLoad] = useState(true);

  const [totalCalls, setTotalCalls] = useState(
    () => localStorage.getItem("totalCallsExisting") || 0
  );



  const [selectedFilter, setSelectedFilter] = useState(() => localStorage.getItem("selectedFilterExisting") || "this-month");



  const [loading, setLoading] = useState(false);
  const [loadingPayments, setLoadingPayments] = useState(false);


  const [openModal, setOpenModal] = useState(false);


  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");

  // ⬇️ add separate states
  const [loadingMain, setLoadingMain] = useState(false);        // header refresh
  const [loadingMonthly, setLoadingMonthly] = useState(false);  // month wise payments
  const [loadingLeads, setLoadingLeads] = useState(false);      // leads by source
  const [isAllowed, setIsAllowed] = useState(true);
  const [isAllowedMonthly, setIsAllowedMonthly] = useState(false);



  const [clickCount, setClickCount] = useState(0);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("refreshData"));
    const now = Date.now();

    if (stored) {
      const timePassed = now - stored.timestamp;

      if (timePassed < 3600000) {
        setClickCount(stored.count);
        setIsAllowed(stored.count < 2);
      } else {
        // Reset after 1 hour
        localStorage.setItem(
          "refreshData",
          JSON.stringify({ count: 0, timestamp: now })
        );
        setClickCount(0);
        setIsAllowed(true);
      }
    } else {
      localStorage.setItem(
        "refreshData",
        JSON.stringify({ count: 0, timestamp: now })
      );
      setClickCount(0);
      setIsAllowed(true);
    }
  }, []);




  const handleRefresh = async () => {
    const stored = JSON.parse(localStorage.getItem("refreshData"));
    const now = Date.now();

    if (stored && stored.count >= 2 && now - stored.timestamp < 3600000) {
      alert("Limit reached! Try again after 1 hour.");
      return;
    }

    setLoadingMain(true);
    setIsAllowed(false); // ⬅ Disable button immediately

    const newCount =
      stored && now - stored.timestamp < 3600000 ? stored.count + 1 : 1;

    localStorage.setItem(
      "refreshData",
      JSON.stringify({ count: newCount, timestamp: now })
    );

    setClickCount(newCount);

    try {
      await Promise.all([
        fetchCount(selectedFilter, customStart, customEnd),
        fetchAverageDonation(selectedFilter, customStart, customEnd),
        fetchUniqueContacts(selectedFilter, customStart, customEnd),
        fetchUpgradeRate(selectedFilter, customStart, customEnd),
        fetchReactivationRate(selectedFilter, customStart, customEnd),
        fetchResolutionDate(selectedFilter, customStart, customEnd),
        fetchRevenue(selectedFilter, customStart, customEnd),
        fetchContactRate(selectedFilter, customStart, customEnd),
      ]);
    } finally {
      setLoadingMain(false);

      // Enable button after exactly 1 hour
      setTimeout(() => {
        setIsAllowed(true);
        setClickCount(0);
        localStorage.setItem(
          "refreshData",
          JSON.stringify({ count: 0, timestamp: Date.now() })
        );
      }, 3600000); // 1 hour = 3600000 ms
    }
  };




  const [monthlyClickCount, setMonthlyClickCount] = useState(0);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("monthlyRefreshData"));
    const now = Date.now();

    if (stored && stored.timestamp) {
      const timePassed = now - stored.timestamp;

      if (timePassed < 3600000) {
        // Within 1 hour → keep count
        setMonthlyClickCount(stored.count);
        setIsAllowedMonthly(stored.count < 2);
        return;
      }
    }

    // Initialize / reset if no stored or 1 hour passed
    localStorage.setItem(
      "monthlyRefreshData",
      JSON.stringify({ count: 0, timestamp: now })
    );
    setMonthlyClickCount(0);
    setIsAllowedMonthly(true);
  }, []);









  // fetchCount with filter
  const fetchCount = async (filter, startDate, endDate) => {
    try {
      setLoading(true);
      const res = await fetch("/server/dealer_backend/getCallsCountExisting", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dealerEmail: dealerDetail?.dealerDetail?.Email,
          filter,
          startDate, // only needed if custom
          endDate,
        }),
      });

      const data = await res.json();
      if (data.status === "success") {
        setTotalCalls(data.totalCalls);
        localStorage.setItem("totalCallsExisting", data.totalCalls);
      }
    } catch (error) {
      console.error("Error fetching total calls:", error);
    } finally {
      setLoading(false);
    }
  };




  // handle filter change





  // Load saved value from localStorage when component mounts
  useEffect(() => {
    const savedCount = localStorage.getItem("totalCallsExisting'");
    if (savedCount) {
      setTotalCalls(savedCount);
    }
  }, []);






  const [averageDonation, setAverageDonation] = useState(() => {
    return localStorage.getItem("averageDonationExisting") || 0;
  });


  // 🟢 API function (only called on refresh or filter change)
  const fetchAverageDonation = async (filter, customStart, customEnd) => {
    try {
      setLoading(true);
      const res = await fetch("/server/dealer_backend/getAverageDonationExisting", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dealerEmail: dealerDetail?.dealerDetail?.Email,
          filter,
          startDate: customStart,
          endDate: customEnd,
        }),
      });

      const data = await res.json();
      if (data.status === "success") {
        setAverageDonation(data.averageDonation.toFixed(2));
        localStorage.setItem("averageDonationExisting", data.averageDonation.toFixed(2));
      }
    } catch (error) {
      console.error("Error fetching average donation:", error);
    } finally {
      setLoading(false);
    }
  };

  // 🟡 On first mount → only read from localStorage, no API call
  useEffect(() => {
    const saved = localStorage.getItem("averageDonationExisting");
    if (saved) {
      setAverageDonation(saved);
    }
  }, []);

  // 🟣 On filter change → only call API if user actively changes filter (not on mount)
  const handleFilterChange = (newFilter, save = true) => {
    setSelectedFilter(newFilter);

    if (save) {
      localStorage.setItem("selectedFilterExisting", newFilter);
    }

    if (newFilter === "custom") {
      setOpenModal(true);
      return; // No API call, so no click count increase
    }

    // 🚨 If it's a normal filter (not custom), check limit BEFORE making API calls
    if (clickCount >= 2) {
      console.log("Daily API limit reached");
      return;
    }

    // 👉 Increase click count only when APIs are triggered
    setClickCount(prev => {
      const newCount = prev + 1;
      localStorage.setItem(
        "refreshData",
        JSON.stringify({ date: new Date().toDateString(), count: newCount })
      );
      return newCount;
    });

    // 📞 Trigger API calls for selected filter
    fetchCount(newFilter);
    fetchAverageDonation(newFilter);
    fetchUpgradeRate(newFilter);
    fetchRevenue(newFilter);
    fetchContactRate(newFilter);
    fetchUniqueContacts(newFilter);
    fetchReactivationRate(newFilter);
    fetchResolutionDate(newFilter);
  };


  const [dailyRevenue, setDailyRevenue] = useState(localStorage.getItem("dailyRevenue") || 0);
  const [weeklyRevenue, setWeeklyRevenue] = useState(localStorage.getItem("weeklyRevenue") || 0);

  const [loadingDaily, setLoadingDaily] = useState(false);
  const [loadingWeekly, setLoadingWeekly] = useState(false);


  const fetchRevenue = async (filter, customStart, customEnd) => {
    try {
      setLoadingDaily(true);
      const res = await fetch("/server/dealer_backend/getRevenue", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dealerEmail: dealerDetail?.dealerDetail?.Email,
          filter, // pass filter
          startDate: customStart,
          endDate: customEnd,
        }),
      });

      const data = await res.json();
      if (data.status === "success") {
        setDailyRevenue(data.data.revenue); // 🔥 same for weekly/monthly since API is dynamic
        localStorage.setItem("revenue", data.data.revenue);
      }
    } catch (err) {
      console.error("Error fetching revenue:", err);
    } finally {
      setLoadingDaily(false);
    }
  };



  // 🟢 State
  const [contactRate, setContactRate] = useState(
    localStorage.getItem("contactRateExisting") || 0
  );
  const [loadingContact, setLoadingContact] = useState(false);

  // 🟢 API Call
  const fetchContactRate = async (filter, customStart, customEnd) => {
    try {
      setLoadingContact(true);
      const res = await fetch("/server/dealer_backend/getContactRate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dealerEmail: dealerDetail.dealerDetail?.Email,
          filter,
          startDate: customStart,
          endDate: customEnd,
        }),
      });

      const data = await res.json();
      if (data.status === "success") {
        setContactRate(data.data.conversionRate); // 👈 backend still returns conversionRate key
        localStorage.setItem("contactRateExisting", data.data.conversionRate);
      }
    } catch (err) {
      console.error("Error fetching contact rate:", err);
    } finally {
      setLoadingContact(false);
    }
  };

  const [upgradeRate, setUpgradeRate] = useState(
    localStorage.getItem("upgradeRate") || 0
  );
  const [loadingUpgrade, setLoadingUpgrade] = useState(false);

  const fetchUpgradeRate = async (filter, customStart, customEnd) => {
    try {
      setLoadingUpgrade(true);
      const res = await fetch("/server/dealer_backend/getUpgradeRate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dealerEmail: dealerDetail.dealerDetail?.Email,
          filter,
          startDate: customStart,
          endDate: customEnd,
        }),
      });

      const data = await res.json();
      if (data.status === "success") {
        // console.log({data})
        setUpgradeRate(data.upgradeRate);
        localStorage.setItem("upgradeRate", data.upgradeRate);
      }
    } catch (err) {
      console.error("Error fetching upgrade rate:", err);
    } finally {
      setLoadingUpgrade(false);
    }
  };



  const [reactivationRate, setReactivationRate] = useState(
    localStorage.getItem("reactivationRate") || 0
  );

  const [loadingReactivation, setLoadingReactivation] = useState(false);

  const fetchReactivationRate = async (filter, customStart, customEnd) => {
    try {
      setLoadingUpgrade(true);
      const res = await fetch("/server/dealer_backend/getReactivationRate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dealerEmail: dealerDetail.dealerDetail?.Email,
          filter,
          startDate: customStart,
          endDate: customEnd,
        }),
      });

      const data = await res.json();
      if (data.status === "success") {
        // console.log({data})
        setReactivationRate(data.data.reactivationRate);
        localStorage.setItem("reactivationRate", data.data.reactivationRate);
      }
    } catch (err) {
      console.error("Error fetching reactivation rate:", err);
    } finally {
      setLoadingReactivation(false);
    }
  };

  const [resolutionDate, setResolutionDate] = useState(
    localStorage.getItem("firstResolutionDateExisting") || ""
  );



  const fetchResolutionDate = async (filter, start, end) => {
    try {
      const response = await fetch("/server/dealer_backend/firstResolutionDateExisting", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Add auth token if needed
        },
        body: JSON.stringify({
          dealerEmail: dealerDetail?.dealerDetail?.Email,
          filter,
          startDate: start,
          endDate: end,
        }),
      });

      const data = await response.json();
      if (data.status === "success") {
        // Assuming backend now returns the date as 'firstResolutionDate'
        const rate = data.uniqueContacts || "";
        setResolutionDate(rate);
        localStorage.setItem("firstResolutionDateExisting", rate);
      }
    } catch (error) {
      console.error("Error fetching first resolution date:", error);
    }
  };






  // const [monthlyData, setMonthlyData] = useState([]);




  const dealerEmail = dealerDetail?.Email; // replace with real auth user

  // ✅ Load cached data from localStorage when component mounts
  // ✅ API Fetch now accepts year as argument


  // ✅ Fetch or load from localStorage
  // ✅ Load cached data from localStorage when component mounts
  const [monthlyData, setMonthlyData] = useState(() => {
    const cached = localStorage.getItem("monthlyPaymentsExisting");
    return cached ? JSON.parse(cached).data || [] : [];
  });
  const [selectedYear, setSelectedYear] = useState(() => {
    const cached = localStorage.getItem("monthlyPaymentsExisting");
    return cached ? JSON.parse(cached).year || new Date().getFullYear() : new Date().getFullYear();
  });

  // ✅ API Fetch
  const fetchMonthlyData = async (year) => {
    if (!isAllowedMonthly) return;

    setLoadingPayments(true);

    const now = Date.now();

    setMonthlyClickCount(prev => {
      const newCount = prev + 1;

      localStorage.setItem(
        "monthlyRefreshData",
        JSON.stringify({
          count: newCount,
          timestamp: now   // 🔥 FIX: store a timestamp
        })
      );

      return newCount;
    });

    try {
      const res = await fetch("/server/dealer_backend/getMonthlyPaymentSumsExisting", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dealerEmail: dealerDetail.dealerDetail?.Email,
          year,
        }),
      });

      const data = await res.json();

      if (data.status === "success") {
        setMonthlyData(data.data);
        localStorage.setItem("monthlyPaymentsExisting", JSON.stringify({ data: data.data, year }));
      }
    } catch (err) {
      console.error("Error fetching monthly payments:", err);
    } finally {
      setLoadingPayments(false);
    }
  };



  // ✅ handle year change: change state + trigger API
  const handleYearChange = (e) => {
    const newYear = Number(e.target.value);
    setSelectedYear(newYear);
    fetchMonthlyData(newYear); // pass it explicitly
  };


  const getLastFiveYearsOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 5 }, (_, i) => currentYear - i).map((yr) => (
      <option key={yr} value={yr}>
        {yr}
      </option>
    ));
  };



  const [uniqueContacts, setUniqueContacts] = useState(0);

  const fetchUniqueContacts = async (filter, customStart, customEnd) => {
    try {
      const res = await fetch("/server/dealer_backend/getUniqueContactsReached", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          dealerEmail: dealerDetail.dealerDetail?.Email, // optional if needed
          filter,
          startDate: customStart,
          endDate: customEnd,
        }),
      });

      if (!res.ok) throw new Error("Network response was not ok");

      const data = await res.json();
      if (data.status === "success") {
        setUniqueContacts(data.uniqueContacts || 0);
        localStorage.setItem("uniqueContacts", data.uniqueContacts || 0);
      }
    } catch (err) {
      console.error("Error fetching unique contacts", err);
    }
  };


  // ✅ Remove localStorage usage entirely
  // ❌ delete useEffect that loads from localStorage






  const formattedFilter = filter
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
  return (



    <div className="p-6 mt-[-65px] ">
      {/* Header */}






      <div>
        {/* Filters & Refresh */}
        <div className="flex items-end gap-4 justify-end mb-4">
          {/* Filter Dropdown */}
          <div className="w-[180px]">
            <select
              value={selectedFilter}
              onChange={(e) => handleFilterChange(e.target.value)}
              className="w-full py-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:border-blue-500"
            >
              <option value="today">Today</option>
              <option value="this-week">This Week</option>
              <option value="last-week">Last Week</option>
              <option value="this-month">This Month</option>
              <option value="last-month">Last Month</option>
              <option value="this-year">This Year</option>
              <option value="last-year">Last Year</option>
              <option value="custom">Custom Range</option>
            </select>
          </div>

          {/* Refresh Button */}
          <button
            onClick={handleRefresh}
            disabled={loadingMain || clickCount >= 2}
            className="flex items-center gap-2 px-4 py-2 bg-[#2070B9] text-white rounded-lg shadow hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <RotateCcw className={`w-4 h-4 ${loadingMain ? "animate-spin" : ""}`} />
            {clickCount >= 2 ? "Limit reached" : "Refresh"}
          </button>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {/* Total Calls */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              {/* Icon */}
              <div className="p-2 bg-green-50 rounded-lg">
                <Phone className="w-6 h-6 text-green-500" />
              </div>

              {/* Text + Value */}
              <div>
                <p className="text-sm text-gray-500">Total Calls Made</p>
                <p className="text-2xl font-bold flex items-center">
                  {loading ? (
                    <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                      <rect x="0" y="14" width="4" height="14" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="8;24;8" dur="1s" repeatCount="indefinite" begin="0s" />
                        <animate attributeName="y" values="18;4;18" dur="1s" repeatCount="indefinite" begin="0s" />
                      </rect>
                      <rect x="8" y="10" width="4" height="18" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="18;8;18" dur="1s" repeatCount="indefinite" begin="0.1s" />
                        <animate attributeName="y" values="10;18;10" dur="1s" repeatCount="indefinite" begin="0.1s" />
                      </rect>
                      <rect x="16" y="7" width="4" height="21" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="21;12;21" dur="1s" repeatCount="indefinite" begin="0.2s" />
                        <animate attributeName="y" values="7;16;7" dur="1s" repeatCount="indefinite" begin="0.2s" />
                      </rect>
                      <rect x="24" y="4" width="4" height="24" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="24;8;24" dur="1s" repeatCount="indefinite" begin="0.3s" />
                        <animate attributeName="y" values="4;20;4" dur="1s" repeatCount="indefinite" begin="0.3s" />
                      </rect>
                      <rect x="32" y="0" width="4" height="28" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="28;12;28" dur="1s" repeatCount="indefinite" begin="0.4s" />
                        <animate attributeName="y" values="0;16;0" dur="1s" repeatCount="indefinite" begin="0.4s" />
                      </rect>
                    </svg>
                  ) : (
                    <>{totalCalls || 0}</>
                  )}
                </p>
              </div>
            </div>
          </div>


          {/* Average Donation */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              {/* Icon */}
              <div className="p-2 bg-purple-50 rounded-lg">
                <ShoppingBag className="w-6 h-6 text-purple-500" />
              </div>

              {/* Text + Value */}
              <div>
                <p className="text-sm text-gray-500">Average Donation</p>
                <p className="text-2xl font-bold flex items-center">
                  {loading ? (
                    <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                      <rect x="0" y="14" width="4" height="14" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="8;24;8" dur="1s" repeatCount="indefinite" begin="0s" />
                        <animate attributeName="y" values="18;4;18" dur="1s" repeatCount="indefinite" begin="0s" />
                      </rect>
                      <rect x="8" y="10" width="4" height="18" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="18;8;18" dur="1s" repeatCount="indefinite" begin="0.1s" />
                        <animate attributeName="y" values="10;18;10" dur="1s" repeatCount="indefinite" begin="0.1s" />
                      </rect>
                      <rect x="16" y="7" width="4" height="21" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="21;12;21" dur="1s" repeatCount="indefinite" begin="0.2s" />
                        <animate attributeName="y" values="7;16;7" dur="1s" repeatCount="indefinite" begin="0.2s" />
                      </rect>
                      <rect x="24" y="4" width="4" height="24" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="24;8;24" dur="1s" repeatCount="indefinite" begin="0.3s" />
                        <animate attributeName="y" values="4;20;4" dur="1s" repeatCount="indefinite" begin="0.3s" />
                      </rect>
                      <rect x="32" y="0" width="4" height="28" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="28;12;28" dur="1s" repeatCount="indefinite" begin="0.4s" />
                        <animate attributeName="y" values="0;16;0" dur="1s" repeatCount="indefinite" begin="0.4s" />
                      </rect>
                    </svg>
                  ) : (
                    <>₹ {averageDonation || 0}</>
                  )}
                </p>
              </div>
            </div>
          </div>




          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              {/* Icon */}
              <div className="p-2 bg-orange-50 rounded-lg">
                <Package className="w-6 h-6 text-orange-500" />
              </div>

              {/* Text + Value */}
              <div>
                <p className="text-sm text-gray-500">Revenue</p>
                <p className="text-2xl font-bold flex items-center">
                  {loading ? (
                    <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                      <rect x="0" y="14" width="4" height="14" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="8;24;8" dur="1s" repeatCount="indefinite" begin="0s" />
                        <animate attributeName="y" values="18;4;18" dur="1s" repeatCount="indefinite" begin="0s" />
                      </rect>
                      <rect x="8" y="10" width="4" height="18" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="18;8;18" dur="1s" repeatCount="indefinite" begin="0.1s" />
                        <animate attributeName="y" values="10;18;10" dur="1s" repeatCount="indefinite" begin="0.1s" />
                      </rect>
                      <rect x="16" y="7" width="4" height="21" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="21;12;21" dur="1s" repeatCount="indefinite" begin="0.2s" />
                        <animate attributeName="y" values="7;16;7" dur="1s" repeatCount="indefinite" begin="0.2s" />
                      </rect>
                      <rect x="24" y="4" width="4" height="24" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="24;8;24" dur="1s" repeatCount="indefinite" begin="0.3s" />
                        <animate attributeName="y" values="4;20;4" dur="1s" repeatCount="indefinite" begin="0.3s" />
                      </rect>
                      <rect x="32" y="0" width="4" height="28" rx="2" fill="#9333EA">
                        <animate attributeName="height" values="28;12;28" dur="1s" repeatCount="indefinite" begin="0.4s" />
                        <animate attributeName="y" values="0;16;0" dur="1s" repeatCount="indefinite" begin="0.4s" />
                      </rect>
                    </svg>
                  ) : (
                    <>₹ {dailyRevenue || 0}</>
                  )}
                </p>
              </div>
            </div>
          </div>


          {/* Conversion Rate */}

          {/* Contact Rate */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              {/* Icon */}
              <div className="p-2 bg-yellow-50 rounded-lg">
                <PhoneCall className="w-6 h-6 text-yellow-500" />
              </div>

              {/* Text + Value */}
              <div>
                <p className="text-sm text-gray-500">Contact Rate</p>
                <p className="text-2xl font-bold flex items-center">
                  {loading ? (
                    <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                      <rect x="0" y="14" width="4" height="14" rx="2" fill="#FACC15">
                        <animate attributeName="height" values="8;24;8" dur="1s" repeatCount="indefinite" begin="0s" />
                        <animate attributeName="y" values="18;4;18" dur="1s" repeatCount="indefinite" begin="0s" />
                      </rect>
                      <rect x="8" y="10" width="4" height="18" rx="2" fill="#FACC15">
                        <animate attributeName="height" values="18;8;18" dur="1s" repeatCount="indefinite" begin="0.1s" />
                        <animate attributeName="y" values="10;18;10" dur="1s" repeatCount="indefinite" begin="0.1s" />
                      </rect>
                      <rect x="16" y="7" width="4" height="21" rx="2" fill="#FACC15">
                        <animate attributeName="height" values="21;12;21" dur="1s" repeatCount="indefinite" begin="0.2s" />
                        <animate attributeName="y" values="7;16;7" dur="1s" repeatCount="indefinite" begin="0.2s" />
                      </rect>
                      <rect x="24" y="4" width="4" height="24" rx="2" fill="#FACC15">
                        <animate attributeName="height" values="24;8;24" dur="1s" repeatCount="indefinite" begin="0.3s" />
                        <animate attributeName="y" values="4;20;4" dur="1s" repeatCount="indefinite" begin="0.3s" />
                      </rect>
                      <rect x="32" y="0" width="4" height="28" rx="2" fill="#FACC15">
                        <animate attributeName="height" values="28;12;28" dur="1s" repeatCount="indefinite" begin="0.4s" />
                        <animate attributeName="y" values="0;16;0" dur="1s" repeatCount="indefinite" begin="0.4s" />
                      </rect>
                    </svg>
                  ) : (
                    <>{contactRate || 0}%</>
                  )}
                </p>
              </div>
            </div>
          </div>




          {/* Follow-Up Success Rate */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              {/* Icon */}
              <div className="p-2 bg-red-50 rounded-lg">
                <PhoneCall className="w-6 h-6 text-red-500" />
              </div>

              {/* Text + Value */}
              <div>
                <p className="text-sm text-gray-500">Upgrade Rate</p>
                <p className="text-2xl font-bold flex items-center">
                  {loading ? (
                    <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                      <rect x="0" y="14" width="4" height="14" rx="2" fill="#c52822ff">
                        <animate attributeName="height" values="8;24;8" dur="1s" repeatCount="indefinite" begin="0s" />
                        <animate attributeName="y" values="18;4;18" dur="1s" repeatCount="indefinite" begin="0s" />
                      </rect>
                      <rect x="8" y="10" width="4" height="18" rx="2" fill="#c52822ff">
                        <animate attributeName="height" values="18;8;18" dur="1s" repeatCount="indefinite" begin="0.1s" />
                        <animate attributeName="y" values="10;18;10" dur="1s" repeatCount="indefinite" begin="0.1s" />
                      </rect>
                      <rect x="16" y="7" width="4" height="21" rx="2" fill="#c52822ff">
                        <animate attributeName="height" values="21;12;21" dur="1s" repeatCount="indefinite" begin="0.2s" />
                        <animate attributeName="y" values="7;16;7" dur="1s" repeatCount="indefinite" begin="0.2s" />
                      </rect>
                      <rect x="24" y="4" width="4" height="24" rx="2" fill="#c52822ff">
                        <animate attributeName="height" values="24;8;24" dur="1s" repeatCount="indefinite" begin="0.3s" />
                        <animate attributeName="y" values="4;20;4" dur="1s" repeatCount="indefinite" begin="0.3s" />
                      </rect>
                      <rect x="32" y="0" width="4" height="28" rx="2" fill="#c52822ff">
                        <animate attributeName="height" values="28;12;28" dur="1s" repeatCount="indefinite" begin="0.4s" />
                        <animate attributeName="y" values="0;16;0" dur="1s" repeatCount="indefinite" begin="0.4s" />
                      </rect>
                    </svg>
                  ) : (
                    <>{upgradeRate || 0}%</>
                  )}
                </p>

                {/* Optional: breakdown */}
                {/* <p className="text-xs text-gray-400">
        {upgradeCount}/{totalDonors} upgraded
      </p> */}
              </div>
            </div>
          </div>



          {/* Unique Contacts */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              {/* Icon */}
              <div className="p-2 bg-pink-50 rounded-lg">
                <Users className="w-6 h-6 text-pink-500" />
              </div>

              {/* Text + Value */}
              <div>
                <p className="text-sm text-gray-500">Unique Contacts Reached</p>
                <p className="text-2xl font-bold flex items-center">
                  {loading ? (
                    <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                      <rect x="0" y="14" width="4" height="14" rx="2" fill="#EC4899">
                        <animate attributeName="height" values="8;24;8" dur="1s" repeatCount="indefinite" begin="0s" />
                        <animate attributeName="y" values="18;4;18" dur="1s" repeatCount="indefinite" begin="0s" />
                      </rect>
                      <rect x="8" y="10" width="4" height="18" rx="2" fill="#EC4899">
                        <animate attributeName="height" values="18;8;18" dur="1s" repeatCount="indefinite" begin="0.1s" />
                        <animate attributeName="y" values="10;18;10" dur="1s" repeatCount="indefinite" begin="0.1s" />
                      </rect>
                      <rect x="16" y="7" width="4" height="21" rx="2" fill="#EC4899">
                        <animate attributeName="height" values="21;12;21" dur="1s" repeatCount="indefinite" begin="0.2s" />
                        <animate attributeName="y" values="7;16;7" dur="1s" repeatCount="indefinite" begin="0.2s" />
                      </rect>
                      <rect x="24" y="4" width="4" height="24" rx="2" fill="#EC4899">
                        <animate attributeName="height" values="24;8;24" dur="1s" repeatCount="indefinite" begin="0.3s" />
                        <animate attributeName="y" values="4;20;4" dur="1s" repeatCount="indefinite" begin="0.3s" />
                      </rect>
                      <rect x="32" y="0" width="4" height="28" rx="2" fill="#EC4899">
                        <animate attributeName="height" values="28;12;28" dur="1s" repeatCount="indefinite" begin="0.4s" />
                        <animate attributeName="y" values="0;16;0" dur="1s" repeatCount="indefinite" begin="0.4s" />
                      </rect>
                    </svg>
                  ) : (
                    <>{uniqueContacts || 0}</>
                  )}
                </p>
              </div>
            </div>
          </div>


          {/* Reactivation Rate */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              {/* Icon */}
              <div className="p-2 bg-blue-50 rounded-lg">
                <Users className="w-6 h-6 text-blue-500" />
              </div>

              {/* Text + Value */}
              <div>
                <p className="text-sm text-gray-500">Reactivation Rate</p>
                <p className="text-2xl font-bold flex items-center">
                  {loading ? (
                    <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                      <rect x="0" y="14" width="4" height="14" rx="2" fill="#2070BC">
                        <animate attributeName="height" values="8;24;8" dur="1s" repeatCount="indefinite" begin="0s" />
                        <animate attributeName="y" values="18;4;18" dur="1s" repeatCount="indefinite" begin="0s" />
                      </rect>
                      <rect x="8" y="10" width="4" height="18" rx="2" fill="#2070BC">
                        <animate attributeName="height" values="18;8;18" dur="1s" repeatCount="indefinite" begin="0.1s" />
                        <animate attributeName="y" values="10;18;10" dur="1s" repeatCount="indefinite" begin="0.1s" />
                      </rect>
                      <rect x="16" y="7" width="4" height="21" rx="2" fill="#2070BC">
                        <animate attributeName="height" values="21;12;21" dur="1s" repeatCount="indefinite" begin="0.2s" />
                        <animate attributeName="y" values="7;16;7" dur="1s" repeatCount="indefinite" begin="0.2s" />
                      </rect>
                      <rect x="24" y="4" width="4" height="24" rx="2" fill="#2070BC">
                        <animate attributeName="height" values="24;8;24" dur="1s" repeatCount="indefinite" begin="0.3s" />
                        <animate attributeName="y" values="4;20;4" dur="1s" repeatCount="indefinite" begin="0.3s" />
                      </rect>
                      <rect x="32" y="0" width="4" height="28" rx="2" fill="#2070BC">
                        <animate attributeName="height" values="28;12;28" dur="1s" repeatCount="indefinite" begin="0.4s" />
                        <animate attributeName="y" values="0;16;0" dur="1s" repeatCount="indefinite" begin="0.4s" />
                      </rect>
                    </svg>
                  ) : (
                    <>{reactivationRate || 0}%</>
                  )}
                </p>
              </div>
            </div>
          </div>


          {/* First Call Resolution Rate */}
          <div className="p-6 border rounded-lg shadow-sm bg-white">
            <div className="flex items-center gap-4">
              {/* Icon */}
              <div className="p-2 bg-green-50 rounded-lg">
                <PhoneCall className="w-6 h-6 text-green-500" />
              </div>

              {/* Text + Value */}
              <div>
                <p className="text-sm text-gray-500">First Call Resolution Rate</p>
                <p className="text-2xl font-bold flex items-center">
                  {loading ? (
                    <svg width="40" height="32" viewBox="0 0 40 32" fill="none">
                      <rect x="0" y="14" width="4" height="14" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="8;24;8" dur="1s" repeatCount="indefinite" begin="0s" />
                        <animate attributeName="y" values="18;4;18" dur="1s" repeatCount="indefinite" begin="0s" />
                      </rect>
                      <rect x="8" y="10" width="4" height="18" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="18;8;18" dur="1s" repeatCount="indefinite" begin="0.1s" />
                        <animate attributeName="y" values="10;18;10" dur="1s" repeatCount="indefinite" begin="0.1s" />
                      </rect>
                      <rect x="16" y="7" width="4" height="21" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="21;12;21" dur="1s" repeatCount="indefinite" begin="0.2s" />
                        <animate attributeName="y" values="7;16;7" dur="1s" repeatCount="indefinite" begin="0.2s" />
                      </rect>
                      <rect x="24" y="4" width="4" height="24" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="24;8;24" dur="1s" repeatCount="indefinite" begin="0.3s" />
                        <animate attributeName="y" values="4;20;4" dur="1s" repeatCount="indefinite" begin="0.3s" />
                      </rect>
                      <rect x="32" y="0" width="4" height="28" rx="2" fill="#22C55E">
                        <animate attributeName="height" values="28;12;28" dur="1s" repeatCount="indefinite" begin="0.4s" />
                        <animate attributeName="y" values="0;16;0" dur="1s" repeatCount="indefinite" begin="0.4s" />
                      </rect>
                    </svg>
                  ) : (
                    <>{resolutionDate || 0}%</>
                  )}
                </p>
              </div>
            </div>
          </div>


        </div>

        {/* Month Wise Payments */}
        <div className="bg-white shadow rounded-lg p-6 mt-4">
          <div className="flex justify-between items-center mb-4">
            <h6 className="font-bold">Month Wise Payments</h6>
            <div className="flex gap-4 items-center">
              <select
                className="form-select block w-auto px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                value={selectedYear}
                onChange={handleYearChange}
              >
                {getLastFiveYearsOptions()}
              </select>
              <button
                onClick={() => fetchMonthlyData(selectedYear)}
                disabled={loadingPayments || monthlyClickCount >= 2}
                className="flex items-center gap-1 px-3 py-2 bg-[#2070B9] text-white rounded-lg shadow hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <RotateCcw className={`w-4 h-4 ${loadingPayments ? "animate-spin" : ""}`} />
                {monthlyClickCount >= 2 ? "Limit reached" : "Refresh"}
              </button>
            </div>

          </div>

          <ResponsiveContainer width="100%" height={350}>
            <LineChart data={monthlyData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip formatter={(value) => [`₹${value}`, "Amount"]} />
              <Line
                type="monotone"
                dataKey="total"
                stroke="#3b82f6"
                strokeWidth={2}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Potential Donor by Source */}


        {/* Custom Date Modal */}
        {openModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-xl shadow-lg p-6 w-[400px]">
              <h2 className="text-lg font-semibold mb-4">Select Custom Date Range</h2>
              <div className="flex flex-col gap-4">
                <input
                  type="date"
                  value={customStart}
                  onChange={(e) => setCustomStart(e.target.value)}
                  className="border border-gray-300 rounded-lg px-3 py-2"
                />
                <input
                  type="date"
                  value={customEnd}
                  onChange={(e) => setCustomEnd(e.target.value)}
                  className="border border-gray-300 rounded-lg px-3 py-2"
                />
              </div>
              <div className="flex justify-end gap-3 mt-6">
                <button
                  onClick={() => setOpenModal(false)}
                  className="px-4 py-2 rounded-lg border border-gray-300"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    fetchCount("custom", customStart, customEnd);
                    fetchAverageDonation("custom", customStart, customEnd);
                    fetchUniqueContacts("custom", customStart, customEnd);
                    fetchUpgradeRate("custom", customStart, customEnd);
                    fetchReactivationRate("custom", customStart, customEnd);
                    fetchResolutionDate("custom", customStart, customEnd);
                    fetchRevenue("custom", customStart, customEnd);
                    fetchContactRate("custom", customStart, customEnd);
                    setOpenModal(false);
                  }}
                  disabled={!customStart || !customEnd}
                  className="px-4 py-2 rounded-lg bg-blue-500 text-white disabled:opacity-50"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        )}
      </div>






    </div >


  );
};

export default Dashboard;
